import { useQuery } from '@apollo/client';
import { AdBaseData } from './useAdBaseData';
import { useServerDataContext } from '@/contexts';
import { useResponsive } from '@/hooks/useResponsive';
import { GetUserResponse } from '@/api/types/user.types';
import { GET_USER } from '@/api/queries/user.queries';
import { AdStatus } from '@/types';

export function useAdUiFlags(
  adBaseData: AdBaseData,
  isAuthor: boolean,
  isShop: boolean
) {
  const { hasInitialAdNotFoundError, hasInitialMissingAd } =
    useServerDataContext();
  const { isDesktop } = useResponsive();

  const { data: userInfo } = useQuery<GetUserResponse>(GET_USER);

  const { Published, Expired, Archived, Pending, AwaitingPayment } = AdStatus;
  const { adData, loading, status, hasClientAdNotFoundError } = adBaseData;
  const isExpiredOrPublished = status && [Published, Expired].includes(status);
  const canComplain =
    !isAuthor && isExpiredOrPublished && !userInfo?.currentUser?.isBanned;
  const canBookmark =
    status === Published ||
    (!!status && [Expired, Archived].includes(status) && isAuthor);
  const hasAdNotFoundError =
    hasInitialAdNotFoundError || hasClientAdNotFoundError;
  const shouldShowBanner =
    !isShop && !!status && ![Pending, AwaitingPayment].includes(status);
  const hasFloatingButtons = !isDesktop && !isAuthor && status === Published;
  const shouldShowBurgerInHeader = status === Pending;
  const isLoadedWithoutAdData =
    !adData && (hasInitialMissingAd || (!loading && !hasAdNotFoundError));

  return {
    canComplain,
    canBookmark,
    shouldShowNotFound: hasAdNotFoundError,
    shouldShowBanner,
    hasFloatingButtons,
    shouldShowBurgerInHeader,
    isLoadedWithoutAdData,
  };
}
